import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SERVER_URL } from './ServerConfig';
import axios from 'axios';
import queryString from 'query-string';
import moment from 'moment';
import { Link, withRouter } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { BeatLoader } from 'react-spinners';
import DatePicker from "react-datepicker";

class Alarm extends Component {
    notify = () => {
        toast.error("Could not export alarms report!", {
            position: toast.POSITION.TOP_CENTER
        });
    };

    constructor(props) {
        super(props);

        let params = queryString.parse(this.props.location.search);
        this.state = {
            isLoading: true,
            warnings: [],
            lastAction: null,
            params: params,
            pendingOpenWarning: false,
            openedWarning: null,

            activePage: 0,
            totalPage: 0,

            isEditingExport: false,
            exportReportMessage: '',
            fromDate: null,
            toDate: null,
            exportType: 'all',
            exporting: false,
        }

        this.handleAcknowledgeAll = this.handleAcknowledgeAll.bind(this);
        this.handleOpenWarningDialog = this.handleOpenWarningDialog.bind(this);
        this.handleCloseWarningDialog = this.handleCloseWarningDialog.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);

        this.handlOpenExportWarning = this.handlOpenExportWarning.bind(this);
        this.handleCloseExportWarning = this.handleCloseExportWarning.bind(this);
        this.handleDownloadReport = this.handleDownloadReport.bind(this);

        this.handleFromDateSelect = this.handleFromDateSelect.bind(this);
        this.handleToDateSelect = this.handleToDateSelect.bind(this);

        this.onSelectAllSelected = this.onSelectAllSelected.bind(this);
        this.onSelectDateRangeSelected = this.onSelectDateRangeSelected.bind(this);
    }

    componentDidMount() {
        this.fetchAlarms();
    }

    getModalForm(warning) {
        if (warning.mType === 'CHANGE_STATECODE') {
            return (<form className="form-horizontal" >
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Time</label>
                    <div className="col-sm-9">
                        <input type="text" className="form-control-plaintext" placeholder="" readOnly value={this.getTimeFormat(warning)} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Inverter</label>
                    <div className="col-sm-9">
                        <input type="text" className="form-control-plaintext" placeholder="" readOnly value={warning.inverter.mName} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Status Code</label>
                    <div className="col-sm-9 d-inline-flex align-self-center">
                        <div className="mr-2">
                            {this.getStatus(warning)}
                        </div>
                        {this.getBadgeForStatusCode(warning.code)}
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Description</label>
                    <div className="col-sm-9">
                        <input type="text" className="form-control-plaintext" placeholder="" readOnly value={warning.code.display} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Explaination</label>
                    <div className="col-sm-9" contenteditable="true">
                        {warning.code.statusDescription}
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Action</label>
                    <div className="col-sm-9" contenteditable="true">
                        {warning.code.action}
                    </div>
                </div>
            </form>)
        } else {
            return (<form className="form-horizontal" >
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Time</label>
                    <div className="col-sm-9">
                        <input type="text" className="form-control-plaintext" placeholder="" readOnly value={this.getTimeFormat(warning)} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Inverter</label>
                    <div className="col-sm-9">
                        <input type="text" className="form-control-plaintext" placeholder="" readOnly value={warning.inverter.mName} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Status Code</label>
                    <div className="col-sm-9 d-inline-flex align-self-center">
                        {this.getBadgeForStatus(warning.mNEWStatus)}
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Description</label>
                    <div className="col-sm-9">
                        <input type="text" className="form-control-plaintext" placeholder="" readOnly value={warning.mNote} />
                    </div>
                </div>
            </form>)
        }
    }

    handlOpenExportWarning() {
        this.setState({ isEditingExport: true });
    }

    handleCloseExportWarning() {
        this.setState({ isEditingExport: false, exportReportMessage : '' });
    }

    handleFromDateSelect(selectedDate) {
        this.setState({ fromDate: selectedDate });
    }

    handleToDateSelect(toDate) {
        this.setState({ toDate: toDate });
    }

    getRadioValue(radioButtonId) {
        let exportType = this.state.exportType;
        return (exportType === "all" && radioButtonId === "all-alarms-rd") ||
            (exportType === "dateRange" && radioButtonId === "dr-alarms-rd");
    }

    onSelectAllSelected() {
        this.setState({ exportType: "all" });
    }

    onSelectDateRangeSelected() {
        this.setState({ exportType: "dateRange" });
    }

    getClassForDateRangeForm() {
        let exportType = this.state.exportType;
        if (exportType === "all") {
            return "form-horizontal disabledForm";
        }
        return "form-horizontal";
    }

    getExportButtonState() {
        let exportType = this.state.exportType;
        if (exportType === 'all') {
            return false;
        }
        return this.state.fromDate && this.state.toDate ? "false" : "true";
    }

    getExportButtonModal() {
        let isExporting = this.state.exporting;
        if (isExporting) {
            return (
                <Button variant="success" disabled>
                    Downloading...
                </Button>
            );
        }
        let exportType = this.state.exportType;
        let shouldEnable = exportType === "all" || (this.state.fromDate && this.state.toDate);
        if (shouldEnable) {
            return (
                <Button variant="success" onClick={this.handleDownloadReport}>
                    Export
                </Button>
            );
        } else {
            return (
                <Button variant="success" onClick={this.handleDownloadReport} disabled>
                    Export
                </Button>
            );
        }
    }

    getExportWarningModal() {
        let isEditingExport = this.state.isEditingExport;
        if (isEditingExport) {
            return (
                <Modal show={this.state.isEditingExport} onHide={this.handleCloseExportWarning} animation={false} >
                    <Modal.Header closeButton>
                        <Modal.Title>Export alarms report</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div className="text-center">
                                <p className="text-danger">{this.state.exportReportMessage}</p>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="all-alarms-rd" id="all-alarms-rd"
                                    checked={this.getRadioValue("all-alarms-rd")} onChange={this.onSelectAllSelected} />
                                <label class="form-check-label" for="all-alarms-rd">
                                    All alarms
                                </label>
                            </div>
                            <div class="form-check mt-2">
                                <input class="form-check-input" type="radio" name="dr-alarms-rd" id="dr-alarms-rd"
                                    checked={this.getRadioValue("dr-alarms-rd")} onChange={this.onSelectDateRangeSelected} />
                                <label class="form-check-label" for="dr-alarms-rd">
                                    Date range
                                </label>
                                <form className={this.getClassForDateRangeForm()}>
                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label">From</label>
                                        <div className="col-sm-9">
                                            <DatePicker dateFormat="dd/MM/yyyy"
                                                selected={this.state.fromDate}
                                                startDate={this.state.fromDate}
                                                endDate={this.state.toDate}
                                                className="day-picker-input form-control form-control-sm"
                                                onChange={date => this.handleFromDateSelect(date)} todayButton="Today" />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-3 col-form-label">To</label>
                                        <div className="col-sm-9">
                                            <DatePicker dateFormat="dd/MM/yyyy"
                                                selected={this.state.toDate}
                                                startDate={this.state.fromDate}
                                                endDate={this.state.toDate}
                                                minDate={this.state.fromDate}
                                                className="day-picker-input form-control form-control-sm"
                                                onChange={date => this.handleToDateSelect(date)} todayButton="Today" />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="default" onClick={this.handleCloseExportWarning}>
                            Close
                        </Button>
                        {this.getExportButtonModal()}
                    </Modal.Footer>
                </Modal>
            );
        }
    }

    getOpenWarningModal() {
        let warning = this.state.openedWarning;
        if (warning) {
            return (
                <Modal show={this.state.pendingOpenWarning} onHide={this.handleCloseWarningDialog} animation={false} >
                    <Modal.Body>
                        {this.getModalForm(warning)}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="default" onClick={this.handleCloseWarningDialog}>
                            Close
                            </Button>
                    </Modal.Footer>
                </Modal>
            );
        }
    }

    handleCloseWarningDialog(event) {
        this.setState({ openedWarning: null, pendingOpenWarning: false });
    }

    handleOpenWarningDialog(event, warning) {
        this.setState({ openedWarning: warning, pendingOpenWarning: true });
    }

    fetchAlarms() {
        this.setState({ isLoading: true });
        let token = this.props.user.payload.token;
        let stationId = this.state.params.station;
        fetch(SERVER_URL + '/v1/stations/' + stationId + '/allWarnings', {
            headers: {
                'x-access-token': token
            }
        }).then(response => {
            if (response.status === 403) {
                this.props.history.push("/login");
            } else {
                return response.json();
            }
        })
            .then(data => {
                if (data.success) {
                    let allWarnings = data.content.warnings;
                    let totalPage = Math.floor(allWarnings.length / 10) + 1;
                    if (allWarnings.length % 10 === 0 && allWarnings.length > 0) {
                        totalPage = allWarnings.length / 10;
                    }
                    this.setState({ isLoading: false, warnings: allWarnings, lastAction: data.content.lastAction, totalPage: totalPage })
                }
            });
    }

    getBadgeForStatus(status) {
        if (status === 'true') {
            return (<span className="badge bg-success">ON</span>);
        }
        return (<span className="badge bg-danger">OFF</span>);
    }

    getBadgeForStatusCode(code) {
        if (code.code === 4) {
            return (<span className="badge bg-success">OK</span>);
        }
        if (code.led === 'error') {
            return (<span className="badge bg-danger">Error</span>);
        }
        return (<span className="badge bg-warning">Warning</span>);
    }

    getItems(warning, idx) {
        return (
            <tr key={warning._id}>
                <td scope="row">
                    {this.getTimeWithStatus(warning)}
                </td>
                <td scope="row">
                    {this.getInverterLink(warning)}
                </td>
                <td>{this.getStatus(warning)}</td>
                <td>{this.getDescription(warning)}</td>
                <td style={{ width: '100px' }}>{this.getItemAction(warning)}</td>
            </tr>
        );
    }

    getItemAction(warning) {
        return (<a className="btn btn-info btn-sm" href="#" onClick={e => this.handleOpenWarningDialog(e, warning)}>
            <i className="fas fa-folder mr-1">
            </i>
        View
        </a>);
    }

    getInverterLink(warning) {
        let inverter = warning.inverter;
        return (<Link to={"/inverter?id=" + inverter._id}>
            <div>{inverter.mName}</div>
        </Link>);
    }

    

    getStatus(warning) {
        if (warning.mType === 'CHANGE_STATECODE') {
            if (warning.code && warning.code.code) {
                return warning.code.code;
            }
            return parseInt(warning.mNEWStatus, 16);
        } else {
            return warning.mType === "true" ? "ON" : "OFF";
        }
    }

    getTimeWithStatus(warning) {
        if (!this.state.lastAction) {
            return this.getTimeFormat(warning);
        }
        let time = moment(warning.mTime);
        if (time.isAfter(moment(this.state.lastAction))) {
            return (<div>
                {this.getTimeFormat(warning)}
                <span className="ml-2 badge bg-danger">New</span>
            </div>)
        }
        return this.getTimeFormat(warning);
    }

    getTimeFormat(warning) {
        return moment(warning.mTime).format("DD-MM-YYYY HH:mm");
    }

    getDescription(warning) {
        if (warning.mType === 'CHANGE_STATECODE' && warning.code) {
            let code = warning.code;
            if (code.code === 4) {
                return (<div className="text-success">{code.display}</div>);
            }
            if (code.led === 'error') {
                return (<div className="text-danger">{code.display}</div>);
            }
            return (<div className="log-warn">{code.display}</div>);
        } else {
            if (warning.mNEWStatus === 'true') {
                return (<div className="text-success">{warning.mNote}</div>);
            } else {
                return (<div className="text-danger">{warning.mNote}</div>);
            }
        }
    }


    getTableContent(warnings) {
        if (this.state.isLoading) {
            return null;
        } else {
            return warnings.map((item, idx) => {
                return this.getItems(item, idx);
            })
        }
    }

    isOwner() {
        let user = this.props.user.payload.user;
        return user.member.mRole === 'owner';
    }

    getAcknowledAllButton() {
        let allWarnings = this.state.warnings;
        if (allWarnings && allWarnings.length > 0) {
            return (
                <button type="button" className="btn btn-primary btn-md" onClick={this.handleAcknowledgeAll}>
                    <i className="fas fa-check mr-1"></i>
                Acknowledge All
                </button>
            );
        }
    }

    getButtonBar() {
        if (this.isOwner()) {
            return (<div className="mr-1 ">
                <div className="d-flex justify-content-end">
                    {/* <button type="button" className="btn btn-success btn-md mr-2" onClick={this.handlOpenExportWarning}>
                        <i className="fas fa-download mr-1"></i>
                        Export
                    </button> */}
                    {this.getAcknowledAllButton()}
                </div>
            </div>)
        }
        return (
            <div></div>
        );
    }

    handleDownloadReport() {
        this.setState({ exporting: true });
        let token = this.props.user.payload.token;
        let stationId = this.state.params.station;
        let exporType = this.state.exportType;
        let body = {};
        if (exporType === 'dateRange') {
            body.fromDate = moment(this.state.fromDate).startOf('day');
            body.toDate = moment(this.state.toDate).endOf('day');
        }
        fetch(SERVER_URL + '/v1/stations/' + stationId + '/downloadWarningsReport', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': token,
            },
            body: JSON.stringify(body)
        })
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    return response.blob();
                } if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    throw new Error(response);
                }
            })
            .then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = 'SolarMonitoring-Alarms-report.xlsx';
                a.click();
                this.setState({ exporting: false, isEditingExport: false, exportReportMessage : '' });
            }).catch(err => {
                this.setState({ exporting: false, exportReportMessage: "Could not export report" });
            })

    }

    handleAcknowledgeAll() {
        let token = this.props.user.payload.token;
        let stationId = this.state.params.station;
        fetch(SERVER_URL + '/v1/stations/' + stationId + '/acknowledgeWarnings', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': token,
            },
            body: JSON.stringify({
                time: moment().toISOString()
            })
        }).then(response => {
            if (response.status === 403) {
                this.props.history.push("/login");
            } else {
                return response.json();
            }
        })
            .then(data => {
                if (data.success) {
                    this.fetchAlarms();
                    let station = data.content.station;
                    this.props.handleUpdateStation(station);
                }
            });
    }

    handlePageClick(data) {
        this.setState({ activePage: data.selected });
    }

    getPagination() {
        let allWarnings = this.state.warnings;
        if (allWarnings && allWarnings.length > 0) {
            return (
                <div className="row d-flex justify-content-end mr-1 mt-4">
                    <ReactPaginate
                        previousLabel={'previous'}
                        nextLabel={'next'}
                        breakLabel={'...'}
                        initialPage={this.state.activePage}
                        pageCount={this.state.totalPage}
                        onPageChange={this.handlePageClick}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        containerClassName={'pagination'}
                        activeClassName={'active'}

                        breakClassName={'page-item'}
                        breakLinkClassName={'page-link'}
                        pageClassName={'page-item'}
                        pageLinkClassName={'page-link'}
                        previousClassName={'page-item'}
                        previousLinkClassName={'page-link'}
                        nextClassName={'page-item'}
                        nextLinkClassName={'page-link'}
                    />
                </div>
            );
        }
    }

    getTable() {
        let activePage = this.state.activePage;
        let allWarnings = this.state.warnings;
        if (allWarnings && allWarnings.length === 0) {
            return (
                <div className="main-content d-flex justify-content-center mt-5">
                    <h5>There is no alarm in last 3 days</h5>
                </div>
            )
        }
        let warnings = allWarnings.slice(activePage * 10, (activePage + 1) * 10 - 1);
        return (
            <div className="table-responsive mt-4">
                <table className="table table-bordered table-hover dataTable" cellSpacing="0">
                    <thead>
                        <tr>
                            <th scope="col">Time</th>
                            <th scope="col">Inverter</th>
                            <th scope="col">Status Code</th>
                            <th scope="col">Description</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.getTableContent(warnings)}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div className="main-content d-flex justify-content-center mt-5">
                    <BeatLoader size={30} color="#4A90E2" />
                </div>
            )
        }
        return (
            <div className="content-wrapper">
                <section className="content-header" />
                <section className="content">
                    <div className="container-fluid">
                        {this.getButtonBar()}
                        {this.getTable()}
                        {this.getPagination()}
                    </div>

                    {/* {this.getExportWarningModal()} */}
                    {this.getOpenWarningModal()}
                </section>
                <ToastContainer />
            </div>
        );
    }
}

export default Alarm;
